import React from "react";
import circle_logo from "./assets/circle_logo.png";

export default ({ handleLocChange }) => {
  return (
    <div className="navbar navbar-inverse navbar-fixed-top">
      <div className="navbar-header">
        <a className="navbar-brand">
          <img className="logos" src={circle_logo} alt="circle logo" />
        </a>
        <div className="localizer">
          <a className="loc-opt" onClick={() => handleLocChange("hu")}>
            HU
          </a>
          <b>{"|"}</b>
          <a className="loc-opt" onClick={() => handleLocChange("en")}>
            EN
          </a>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/NavBar.js